import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/exchange-pptx.jpg'


const _hoisted_1 = { class: "choose-files-modal" }
const _hoisted_2 = { class: "tip-text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "1、支持png,jpeg,jpg,mov,mp4,mp3,wav,ogg,aac,flash,pptx文件格式", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " 2、若是本地打开了准备上传的文件，可能会导致上传失败，请关闭文件重新上传 ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 3、ppt需要转化为“.pptx”后缀 ")
const _hoisted_6 = { class: "choose-btns" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("文件上传")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("文件夹导入")
const _hoisted_9 = {
  key: 0,
  class: "pptx-exchange-tip"
}
const _hoisted_10 = { class: "pptx-exchange-tip_content" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QuestionCircleOutlined = _resolveComponent("QuestionCircleOutlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("p", null, [
          _hoisted_5,
          _createVNode(_component_QuestionCircleOutlined, {
            style: { fontSize: '14px', color: '#ff812d', cursor: 'pointer' },
            onClick: _ctx.showPptxExchangeTip
          }, null, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.handleChooseFiles(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.handleChooseFiles(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      (_ctx.pptxExchangeTip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "pptx-exchange-tip_mask",
              onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.showPptxExchangeTip && _ctx.showPptxExchangeTip(...args)))
            }),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_CloseOutlined, {
                onClick: _ctx.showPptxExchangeTip,
                class: "close-icon"
              }, null, 8, ["onClick"]),
              _hoisted_11
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}